import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import 'swiper/css'
import 'swiper/css/pagination'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { getPopup } from '../../api/login'
import { checkTodayBannerPopup } from '../../js/script'
import { useAppContext } from '../provider/AppProvider'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'

interface AdSlideModalProps {
  setAdModal: React.Dispatch<React.SetStateAction<boolean>>
}
export default function AdSlideModal({ setAdModal }: AdSlideModalProps) {
  const { isAppView } = useAppContext()
  const navigate = useNavigate()

  const [item, setItem] = useState<any>([]) // 팝업 아이템

  const handleNavigation = (url: string): void => {
    if (isAppView) {
      // 앱일 때는 단순히 el.clickUrl만 처리
      RNPostMessage(AFWebLinkType.moveToLink, {
        url: `aboutfishing://aboutfishing.com/?page=webview&url=${url}`,
      })
    } else {
      // 외부 링크 처리
      if (url.includes('https://aboutfishing.onelink.me')) {
        window.location.href = url // 외부 링크로 이동
        return
      }

      // 웹일 때만 shopUrl 처리
      const processedUrl = url.includes('shopUrl') ? url.split('shopUrl=')[1] : url
      navigate(processedUrl)
    }
  }

  // 팝업 아이템
  useEffect(() => {
    getPopup().then((res) => {
      setItem(res.data)
    })
  }, [])

  return (
    <>
      {item.length !== 0 && (
        <div className='ad_slide_wrap'>
          <div className='dim'></div>
          <div className='ad_slide_cont'>
            <Swiper
              modules={[Pagination]}
              pagination={{
                type: 'custom',
                renderCustom: (swiper: any, current: number, total: number): string => {
                  return `<span class='swiper-pagination-current'>${current}</span>
                    <span class='swiper-pagination-bar'> / </span>
                    <span class='swiper-pagination-total'>${total}</span>`
                },
              }}
              breakpoints={{
                768: {},
              }}
            >
              {item.length &&
                item.map((el: any) => (
                  <SwiperSlide key={el.popupNo || el.id}>
                    <div onClick={() => handleNavigation(el.clickUrl)}>
                      <div className='popupwrap'>
                        <img src={el.mainImage} alt='' />
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>
            <div className='ad_slide_btn'>
              <button
                type='button'
                onClick={(): void => {
                  checkTodayBannerPopup()
                  setAdModal(false)
                }}
              >
                오늘 그만보기
              </button>
              <i></i>
              <button
                type='button'
                onClick={(): void => {
                  setAdModal(false)
                }}
              >
                닫기
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
